module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.disabled && _vm.show && _vm.$slots.default),
      expression: "!disabled && show && $slots.default"
    }],
    staticClass: "el-tab-pane"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-03c10496!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabs/src/tab-pane.vue
// module id = 599
// module chunks = 0